import React, { useContext, useState, UIEvent, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { i18nContext } from '../i18n/i18nContext';
import { PageNames, PageContext } from '../Home/HomeWork';
import { HeldTimesContext } from '../Root/CompetitionRoot';

import { Box, Button, Checkbox, Container, FormControlLabel, Typography } from "@mui/material";
import { Dialog, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import dayjs from 'dayjs';

import { Title } from "../Component/Title";
import { FormInputType } from './KaguWorkForm';
import { CertificateIndicator } from '../Utility/CertificateIndicator';
import { PDFViewer } from '../../Utility/PDFViewer';
import { CountryDataType } from '../DataFetch/useCountryData';
import { AgreementEn, AgreementJa, ApplicationRulesEn, ApplicationRulesJa } from '../Component/RuleSAndAgreement';

/**
 * このページに渡される要素の型
 */
interface PropsType {
    formData: FormInputType | undefined
    CountryData:CountryDataType[]
}

/**
 * サーバに送信するグループメンバー情報の型
 */
interface GroupArrayType {
    poster: string
    countryId: number
    birthday: string
    educationalInstitution: string
    educationalInstitutionCountryId: number
}

/**
 * 作品登録入力内容確認画面
 * 作品登録フォームに入力された情報を確認する。
 * 作品ファイル、在籍証明のプレビューを表示
 */
export function KaguWorkConfirm({formData, CountryData}:PropsType) {

    //画面再描画用state
    const [refresh, setRefresh] = useState<boolean>(false);

    //グループ情報が表示されないことがあるので、1秒後にstateを更新して画面を再描画する
    useEffect(() => {
        setTimeout(() => setRefresh(true),1000)
        console.log(refresh)
    },[refresh,setRefresh])

    const [t] = useTranslation();

    const {lng} = useContext(i18nContext);

    const {setPage} = useContext(PageContext);

    const heldTimesOption = useContext(HeldTimesContext);

    const ItemSize = 4
    const ValueSize = 8

    function GetCountryDisp(id:number): string {    

        var disp:string = ""

        CountryData.forEach(element => {
            if(element.id === id) {
                disp = element.dropdown_disp;
            }
        });

        return disp
    }

    /**
     * 応募規約スクロール完了フラグ
     */
    const [isRulesScrolled , setIsRulesScrolled] = useState<boolean>(false)

    /**
     * 応募規約チェックボックスフラグ
     */
    const [isRulesChecked, setIsRulesChecked] = useState<boolean>(false)

    /**
     * 応募規約スクロール完了判定
     * @param event イベントデータ
     */
    const scrollApplicationRules = (event: UIEvent<HTMLElement>) => {
        const heightOffset = 5;
        if (event.currentTarget.clientHeight + event.currentTarget.scrollTop >= event.currentTarget.scrollHeight - heightOffset) {
            setIsRulesScrolled (true);
        }       
    }

    const [isOathChecked, setIsOathChecked] = useState<boolean>(false)

    /**
     * 確認ダイアログ表示フラグ
     */
    const [isOpen, setIsOpen] = useState<boolean>(false)

    /**
     * 確認ダイアログ
     */
    function ConfirmDialog() {
        return(
            <>
                <Dialog
                    open={isOpen}
                    onClose={() => setIsOpen(false)}
                >
                    <DialogContent>
                        <DialogContentText>
                            {t("KaguWorkConfirm.Message1")}<br/>
                            {t("KaguWorkConfirm.Message2")}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button id="button-ok" onClick={ClickYes}>{t("KaguWorkConfirm.Yes")}</Button>
                        <Button onClick={() => setIsOpen(false)}>{t("KaguWorkConfirm.No")}</Button>
                    </DialogActions>
                </Dialog>
            </>
        );
    }

    function ClickYes() {

        //処理中表示
        setPage(PageNames.Processing);

        const formData = CreatePostData();

        const fetchAddress = "/competition/api/registration/kmr013"

        fetch(fetchAddress, {
            method:"POST",
            body:formData,
        })
        .then(response => {
            if (response.ok) {
                setPage(PageNames.KaguWorkComplete);
            } else {
                setPage(PageNames.ProcessError);
            }     
        })
        .catch(error => {
            console.error('Error:', error);
            setPage(PageNames.ProcessError);
        });

    }

    function CreatePostData() {

        //在籍証明ファイル名、共通部分
        const postProofFileName = "proofFile"

        const postData = new FormData()

        //作品ファイルを格納
        postData.append("artworkFile", formData?.workFile!)

        //代表者の在籍証明
        postData.append(postProofFileName + "1",formData?.certificate!)

        //グループ情報配列
        var groupArray: GroupArrayType[] = []

        //グループ参加の場合は、グループメンバーの在籍証明と情報を追加する
        if (formData?.group) {
            //グループメンバーの在籍証明
            formData?.members?.forEach((item, index) => {
                postData.append(`${postProofFileName}${index + 2}`,item.certificate!)
            });
            
            //メンバーの数だけJSON形式のデータを作成し、配列に追加
            formData?.members?.forEach(member => {
                const info = {
                    poster: member.name,
                    countryId: member.country,
                    birthday: dayjs(member.birthday).format("YYYY/MM/DD"),
                    educationalInstitution: member.educational,
                    educationalInstitutionCountryId: member.educationalCountry,
                }
                groupArray.push({...info})
            })
        }

        //登録情報のJSONを作成
        const postJson = {
            mainMailaddress: formData?.mailaddress,
            groupFlg: formData?.group,
            mainPoster: formData?.name,
            countryId: formData?.country,
            mainBirthday: dayjs(formData?.birthday).format("YYYY/MM/DD"),
            educationalInstitution: formData?.educational,
            educationalInstitutionCountryId: formData?.educationalCountry,
            interestWork: formData?.product,
            language: lng,
            groupInfo: groupArray,
        }

        const data = JSON.stringify(postJson);
        postData.append("data",data);
        postData.append("json",new Blob([JSON.stringify(postJson)],{type: "application/json;charset=utf-8"}))

        return(postData);
    }

    return(
        <>
            <Box>
                <Title>
                    {t("KaguWorkConfirm.Title1", heldTimesOption)}
                </Title>
            </Box>

            <Container maxWidth="md">
                <Typography
                    variant='h6'
                    sx={{
                        textAlign:"left",
                        mt:2
                    }}
                >
                    {t("KaguWorkConfirm.Item1")}
                </Typography>
                <Grid2 container spacing={1} mt={1}>
                    {/* メールアドレス */}
                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {t("KaguWorkConfirm.MailAddress")}
                    </Grid2>
                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {formData?.mailaddress}
                    </Grid2>
                    {/* 氏名 */}
                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {t("KaguWorkConfirm.Name")}
                    </Grid2>
                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {formData?.name}
                    </Grid2>
                    {/* 国・地域 */}
                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {t("KaguWorkConfirm.Country")}
                    </Grid2>
                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {GetCountryDisp(formData?.country!)}
                    </Grid2>
                    {/* 生年月日 */}
                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {t("KaguWorkConfirm.Birthday")}
                    </Grid2>
                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {lng === "ja" ? dayjs(formData?.birthday).format("YYYY/MM/DD") : dayjs(formData?.birthday).format("MM/DD/YYYY")}
                    </Grid2>
                    {/* 教育機関 */}
                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {t("KaguWorkConfirm.Educational")}
                    </Grid2>
                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {formData?.educational}
                    </Grid2>
                    {/* 国・地域(教育機関) */}
                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex" textAlign="left">
                        {t("KaguWorkConfirm.EducationalCountry")}
                    </Grid2>
                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {GetCountryDisp(formData?.educationalCountry!)}
                    </Grid2>
                    {/* 代表者の在籍証明 */}
                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex" textAlign="left">
                        {t("KaguWorkConfirm.MainCertificate")}
                    </Grid2>
                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {formData?.certificate?.name}
                    </Grid2>
                    {/* 在籍証明のプレビュー */}
                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {t("KaguWorkConfirm.Preview")}
                    </Grid2>
                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                        {CertificateIndicator(formData?.certificate,formData?.certificateBase64)}                        
                    </Grid2>
                </Grid2>

                {/* グループ情報 */}
                {formData?.group ?
                    <Box>
                        <Typography
                            variant='h6'
                            sx={{
                                textAlign:"left",
                                mt:2
                            }}
                        >
                            {t("KaguWorkConfirm.GroupAdditional")}
                        </Typography>

                        {formData?.members?.map((value, index) => (
                            <Box key={value.name} mt={1}>
                                <Grid2 container spacing={1} mt={1} key={value.name}>
                                    {/* メンバー番号 */}
                                    <Grid2 xs={12} flexDirection="row" justifyContent="flex-start" display="flex">
                                        {t("KaguWorkConfirm.Member")}{index + 1}
                                    </Grid2>
                                    {/* 氏名 */}
                                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex">
                                        {t("KaguWorkConfirm.Name")}
                                    </Grid2>
                                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                                        {value?.name}
                                    </Grid2>
                                    {/* 国・地域 */}
                                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex">
                                        {t("KaguWorkConfirm.Country")}
                                    </Grid2>
                                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                                        {GetCountryDisp(value?.country!)}
                                    </Grid2>
                                    {/* 生年月日 */}
                                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex">
                                        {t("KaguWorkConfirm.Birthday")}
                                    </Grid2>
                                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                                        {lng === "ja" ? dayjs(value?.birthday).format("YYYY/MM/DD") : dayjs(value?.birthday).format("MM/DD/YYYY")}
                                    </Grid2>
                                    {/* 教育機関 */}
                                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex">
                                        {t("KaguWorkConfirm.Educational")}
                                    </Grid2>
                                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                                        {value?.educational}
                                    </Grid2>
                                    {/* 国・地域(教育機関) */}
                                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex" textAlign="left">
                                        {t("KaguWorkConfirm.EducationalCountry")}
                                    </Grid2>
                                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                                        {GetCountryDisp(value?.educationalCountry!)}
                                    </Grid2>
                                    {/* 在籍証明 */}
                                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex" textAlign="left">
                                        {t("KaguWorkConfirm.MemberCertificate")}
                                    </Grid2>
                                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                                        {value?.certificate?.name}
                                    </Grid2>
                                    {/* 在籍証明のプレビュー */}
                                    <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex">
                                        {t("KaguWorkConfirm.Preview")}
                                    </Grid2>
                                    <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                                        {CertificateIndicator(value?.certificate, value?.certificateBase64)}                        
                                    </Grid2>
                                </Grid2>
                            </Box>
                        ))}
                    </Box>
                :""}

                {/* 作品ファイル */}
                <Box>
                    <Typography
                        variant='h6'
                        sx={{
                            textAlign:"left",
                            mt:2
                        }}
                    >
                        {t("KaguWorkConfirm.WorkFile")}
                    </Typography>
                    <Grid2 container spacing={1} mt={1}>
                        {/* 作品ファイル名 */}
                        <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex">
                            {t("KaguWorkConfirm.WorkFile")}
                        </Grid2>
                        <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                            {formData?.workFile?.name}
                        </Grid2>
                        {/* 作品ファイルのプレビュー */}
                        <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex">
                            {t("KaguWorkConfirm.Preview")}
                        </Grid2>
                        <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                            {PDFViewer(formData?.workFile, 450)}                 
                        </Grid2>
                        {/* 作品製品化の興味 */}
                        <Grid2 xs={ItemSize} flexDirection="row" justifyContent="flex-start" display="flex" textAlign="left">
                            {t("KaguWorkConfirm.Product")}
                        </Grid2>
                        <Grid2 xs={ValueSize} flexDirection="row" justifyContent="flex-start" display="flex">
                            {formData?.product ? t("KaguWorkConfirm.Yes") : t("KaguWorkConfirm.No")}                 
                        </Grid2>
                    </Grid2>
                </Box>

                {/* 応募規約 */}
                <Box mt={2}>
                    <Typography
                        variant='h6'
                        sx={{
                            textAlign:"left",
                            mt:2
                        }}
                    >
                        {t("KaguWorkConfirm.ApplicationRules")}
                    </Typography>

                    <Box component="div" 
                        sx={{
                            height:400, 
                            overflowY:"scroll", 
                            whiteSpace:"pre-line",
                            textAlign:"left",
                            fontSize:13,
                            p:1,
                            border:1,
                            borderColor:"primary.main"
                        }}      
                        onScroll={scrollApplicationRules}                
                    >
                        {lng === "ja" ? ApplicationRulesJa : ApplicationRulesEn}
                    </Box>
                    <Box flexDirection="row" justifyContent="flex-start" display="flex">
                        <FormControlLabel
                            control={
                                <Checkbox size="small" 
                                    onChange={e => setIsRulesChecked(e.currentTarget.checked)}
                                    disabled={!isRulesScrolled}
                                />
                            } 
                            label={
                                <Typography fontSize={13} textAlign="left" color={isRulesScrolled ? "black" : "grey"}>
                                    {t("KaguWorkConfirm.ConsentApplicationRules")}
                                </Typography>
                            }
                        />
                    </Box>
                </Box>

                {/* 宣誓 */}
                <Box>
                    <Typography
                        variant='h6'
                        sx={{
                            textAlign:"left",
                            mt:1
                        }}
                    >
                        {t("KaguWorkConfirm.Oath")}
                    </Typography>

                    <Box component="div" 
                        sx={{
                            overflowY:"scroll", 
                            whiteSpace:"pre-line",
                            textAlign:"left",
                            fontSize:13,
                            p:1,
                            border:1,
                            borderColor:"primary.main"
                        }}                      
                    >
                        {lng === "ja" ? AgreementJa : AgreementEn}
                    </Box>
                    <Box flexDirection="row" justifyContent="flex-start" display="flex" fontSize={13}>
                        <FormControlLabel
                            control={
                                <Checkbox size="small" 
                                    onChange={e => setIsOathChecked(e.currentTarget.checked)}
                                    
                                />
                            } 
                            label={
                                <Typography fontSize={13} textAlign="left">
                                    {t("KaguWorkConfirm.ConsentOath",heldTimesOption)}
                                </Typography>
                            }                        
                        />
                    </Box>
                </Box>
                
                <Grid2 container spacing={1} mt={2} mb={2}>
                    <Grid2>
                        <Button variant="contained" 
                            onClick={() => setIsOpen(true)}
                            disabled={!(isRulesChecked && isOathChecked)} 
                        >
                            {t("KaguWorkConfirm.Submit")}
                        </Button>
                    </Grid2>
                    <Grid2>
                        <Button variant="outlined" onClick={() => setPage(PageNames.KaguWorkForm)}>{t("Common.Back")}</Button>
                    </Grid2>
                </Grid2>
            </Container>

            <ConfirmDialog/>
        </>
    )
}